import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-course-details-modal',
  templateUrl: './course-details-modal.component.html',
  styleUrls: ['./course-details-modal.component.css']
})
export class CourseDetailsModalComponent implements OnInit {
  course: any;
  activities: any[] = [];
  loading = true;
  error = false;

  constructor(
    public dialogRef: MatDialogRef<CourseDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private trainingService: TrainingService
  ) {
    this.course = data.course;
  }

  ngOnInit(): void {
    if (this.course && this.course.id) {
      this.trainingService.getCourseById(this.course.id).subscribe(
        (res) => {
          if (res && !res.Error && res.Course) {
            this.activities = res.Course.activities || [];
          } else {
            this.error = true;
          }
          this.loading = false;
        },
        () => {
          this.error = true;
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  getPrereqNames(activity: any): string[] {
    if (!activity.prerequisites || !Array.isArray(activity.prerequisites)) return [];
    return activity.prerequisites
      .filter((p: any) => p.prereq_title)
      .map((p: any) => p.prereq_title);
  }
}
